var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { DesktopTabComponent } from '../../../../components/molecules/desktopTabComponent';
import { DynamicFormBuilderContainer } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { Chip, useMediaQuery } from '@mui/material';
import { useAppDispatch } from '../../../../store/hooks';
import { Search } from '@mui/icons-material';
import { FilterIcon } from '../../../../assets/customIcons';
import { showSurface } from '../../../../redux/awaitedSurfacesSlice';
import PSGFilter from '../../PSG/components/PSGFliter';
import { IRsMobileView } from '../../PSG/components/IRsMobileView';
import CQAIRsCatalog from '../components/CQAIRsCatalog';
import closeIRPoup from '../components/closeIRPoup';
import { CloseAFRPopup } from '../../PSG/components/closeAFRpopup';
import AcceptIRPoup from '../components/acceptIRPoup';
import CorrectiveActionsplannedPopup from '../components/CorrectiveActionsplannedPopup';
import { ReactComponent as MoreIconSvg } from '../../../../assets/images/dots-vertical.svg';
import ActionMenuList from '../../../../builderPackage/components/actionsMenuList';
var CQA_IRs = function () {
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var dispatch = useAppDispatch();
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            sx: {
                padding: '16px 24px',
                alignItems: 'center',
                gap: '4px'
            },
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'IRs',
                    columnSize: 0,
                    sx: {
                        fontWeight: 'strong',
                        fontSize: 'xxl'
                    }
                }, {
                    type: FormItemTypes.Chip,
                    name: '',
                    variant: 'filled',
                    color: 'info',
                    shape: 'rounded',
                    label: '300',
                    columnSize: 10
                }, isMobile ? {
                    type: FormItemTypes.Custom,
                    name: 'Header',
                    label: '',
                    element: function () { /*#__PURE__*/ return React.createElement(MoreIconSvg, {
                        color: "secondary.600",
                        onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                            var res;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Menu',
                                            Component: ActionMenuList,
                                            containerProps: {
                                                anchorEl: e === null || e === void 0 ? void 0 : e.target,
                                                anchorOrigin: {
                                                    vertical: 'center',
                                                    horizontal: 'right'
                                                },
                                                transformOrigin: {
                                                    vertical: 'top',
                                                    horizontal: 'right'
                                                }
                                            },
                                            componentProps: {
                                                items: [{
                                                        id: 'ResendToPSG',
                                                        children: ["Resend to PSG"]
                                                    }, {
                                                        id: 'Accept',
                                                        children: ["Accept"]
                                                    }, {
                                                        id: 'CloseIR',
                                                        children: ["Close IR"]
                                                    }]
                                            }
                                        }))];
                                    case 1:
                                        res = _a.sent();
                                        if (!((res === null || res === void 0 ? void 0 : res.payload) === "ResendToPSG")) return [3 /*break*/, 3];
                                        return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Drawer',
                                                Component: CloseAFRPopup,
                                                componentProps: {
                                                    subtitle: 'Failure before corrective actions',
                                                    remarkTitle: 'CQA remarks'
                                                },
                                                containerProps: {
                                                    anchor: 'bottom'
                                                }
                                            }))];
                                    case 2:
                                        _a.sent();
                                        _a.label = 3;
                                    case 3:
                                        if (!((res === null || res === void 0 ? void 0 : res.payload) === "Accept")) return [3 /*break*/, 5];
                                        return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Drawer',
                                                Component: AcceptIRPoup,
                                                containerProps: {
                                                    anchor: 'bottom'
                                                }
                                            }))];
                                    case 4:
                                        _a.sent();
                                        _a.label = 5;
                                    case 5:
                                        if (!((res === null || res === void 0 ? void 0 : res.payload) === "CloseIR")) return [3 /*break*/, 7];
                                        return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Drawer',
                                                Component: closeIRPoup,
                                                containerProps: {
                                                    anchor: 'bottom'
                                                }
                                            }))];
                                    case 6:
                                        _a.sent();
                                        _a.label = 7;
                                    case 7: return [2 /*return*/];
                                }
                            });
                        }); }
                    }); },
                    columnSize: true
                } : null]
        }, {
            type: FormItemTypes.Box,
            name: '',
            height: '76px',
            padding: '16px 24px',
            gap: '12px',
            bgcolor: 'secondary.100',
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: 'secondary.200',
            columnSize: 12,
            justifyContent: 'space-between',
            display: 'flex',
            elements: [{
                    type: FormItemTypes.Stack,
                    name: 'actions',
                    direction: 'row',
                    alignItems: 'center',
                    columnGap: 0.5,
                    borderRadius: 2,
                    px: 1.25,
                    py: 0.5,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'white',
                    width: '100%',
                    // columnSize: 3,
                    maxWidth: 300,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: 'searchButton',
                            columnSize: 0,
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(Search, {
                                color: "secondary"
                            })
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'search',
                            columnSize: true,
                            variant: 'standard',
                            placeholder: 'Search ...',
                            InputProps: {
                                disableUnderline: true
                            }
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    justifyContent: 'end',
                    display: 'flex',
                    columnSize: isMobile ? 2 : 9,
                    gap: isMobile ? '0px' : '12px',
                    elements: [!isMobile ? {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            justifyContent: 'end',
                            sx: {
                                gap: {
                                    xs: '8px',
                                    sm: '8px',
                                    md: '12px'
                                }
                            },
                            elements: [{
                                    type: FormItemTypes.Button,
                                    name: '',
                                    children: "".concat(!isMobile ? "Filters" : ''),
                                    columnSize: 0,
                                    color: 'secondary',
                                    variant: 'outlined',
                                    startIcon: /*#__PURE__*/ React.createElement(FilterIcon, null),
                                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var res;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Drawer',
                                                        Component: PSGFilter,
                                                        containerProps: {
                                                            PaperProps: {
                                                                sx: {
                                                                    width: {
                                                                        xs: '100%',
                                                                        sm: '350px'
                                                                    },
                                                                    borderRadius: {
                                                                        xs: '8px 8px 0 0'
                                                                    }
                                                                }
                                                            },
                                                            anchor: isMobile ? 'bottom' : 'right'
                                                        }
                                                    }))];
                                                case 1:
                                                    res = _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }
                                }, {
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    variant: 'fullWidth',
                                    orientation: 'vertical',
                                    columnSize: 0
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    children: 'Resend to PSG',
                                    columnSize: 0,
                                    color: 'primary',
                                    variant: 'outlined',
                                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Dialog',
                                                        Component: CloseAFRPopup,
                                                        componentProps: {
                                                            subtitle: 'Failure before corrective actions',
                                                            remarkTitle: 'CQA remarks'
                                                        }
                                                    }))];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); },
                                    setFieldProps: function (state) { return ({
                                        type: FormItemTypes.Button,
                                        hidden: (state === null || state === void 0 ? void 0 : state.SelectedButton) == "Received" ? false : true
                                    }); }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    children: 'Accept',
                                    columnSize: 0,
                                    color: 'primary',
                                    variant: 'outlined',
                                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Dialog',
                                                        Component: AcceptIRPoup
                                                    }))];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); },
                                    setFieldProps: function (state) { return ({
                                        type: FormItemTypes.Button,
                                        hidden: (state === null || state === void 0 ? void 0 : state.SelectedButton) == "Received" ? false : true
                                    }); }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    children: 'Close IR',
                                    columnSize: 0,
                                    color: 'primary',
                                    variant: 'outlined',
                                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Dialog',
                                                        Component: closeIRPoup
                                                    }))];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); },
                                    setFieldProps: function (state) { return ({
                                        type: FormItemTypes.Button,
                                        hidden: (state === null || state === void 0 ? void 0 : state.SelectedButton) == "Received" ? false : true
                                    }); }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    children: 'Corrective action planned',
                                    columnSize: 0,
                                    color: 'primary',
                                    variant: 'outlined',
                                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Dialog',
                                                        Component: CorrectiveActionsplannedPopup
                                                    }))];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); },
                                    setFieldProps: function (state) {
                                        return {
                                            type: FormItemTypes.Button,
                                            hidden: (state === null || state === void 0 ? void 0 : state.SelectedButton) == "Accepted" ? false : true
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    children: 'Corrective action implemented',
                                    columnSize: 0,
                                    color: 'primary',
                                    variant: 'outlined',
                                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Dialog',
                                                        Component: closeIRPoup
                                                    }))];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); },
                                    setFieldProps: function (state) {
                                        return {
                                            type: FormItemTypes.Button,
                                            hidden: (state === null || state === void 0 ? void 0 : state.SelectedButton) == "Corrective action planned" ? false : true
                                        };
                                    }
                                }]
                        } : {
                            type: FormItemTypes.Button,
                            name: '',
                            children: "".concat(!isMobile ? "Filters" : ''),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            startIcon: /*#__PURE__*/ React.createElement(FilterIcon, null),
                            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Drawer',
                                                Component: PSGFilter,
                                                containerProps: {
                                                    PaperProps: {
                                                        sx: {
                                                            width: {
                                                                xs: '100%',
                                                                sm: '350px'
                                                            },
                                                            borderRadius: {
                                                                xs: '8px 8px 0 0'
                                                            }
                                                        }
                                                    },
                                                    anchor: isMobile ? 'bottom' : 'right'
                                                }
                                            }))];
                                        case 1:
                                            res = _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            padding: '20px 24px',
            rowGap: '20px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    width: 'auto',
                    sx: {
                        overflowX: 'auto',
                        overflowY: 'visible',
                        flexWrap: 'nowrap',
                        width: '100%',
                        scrollbarWidth: 'none'
                    },
                    position: 'static',
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            width: 'auto',
                            sx: {
                                overflowX: 'auto',
                                overflowY: 'visible',
                                flexWrap: 'nowrap',
                                width: '100%',
                                scrollbarWidth: 'none'
                            },
                            position: 'static',
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    columnSize: 0,
                                    bgcolor: 'secondary.100',
                                    padding: '4px',
                                    borderRadius: '12px',
                                    spacing: 0,
                                    width: 'auto',
                                    border: '1px solid',
                                    borderColor: 'secondary.200',
                                    wrap: 'nowrap',
                                    columnGap: '4px',
                                    elements: [{
                                            type: FormItemTypes.Button,
                                            label: '',
                                            name: 'Received',
                                            columnSize: 0,
                                            variant: 'text',
                                            color: 'secondary',
                                            size: 'small',
                                            setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    return [2 /*return*/, {
                                                            SelectedButton: field.name
                                                        }];
                                                });
                                            }); },
                                            setFieldProps: function (state, value) {
                                                return {
                                                    type: FormItemTypes.Button,
                                                    variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                                    color: 'secondary',
                                                    sx: {
                                                        fontWeight: 'strong',
                                                        color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                        bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                                    },
                                                    children: ['Received', /*#__PURE__*/ React.createElement(Chip, {
                                                            variant: "filled",
                                                            size: "small",
                                                            color: "secondary",
                                                            sx: {
                                                                fontWeight: 'medium',
                                                                color: 'text.primary'
                                                            },
                                                            label: 0
                                                        })]
                                                };
                                            }
                                        }, {
                                            type: FormItemTypes.Button,
                                            label: '',
                                            name: 'Accepted',
                                            columnSize: 0,
                                            variant: 'text',
                                            color: 'secondary',
                                            size: 'small',
                                            fullWidth: true,
                                            setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    return [2 /*return*/, {
                                                            SelectedButton: field.name
                                                        }];
                                                });
                                            }); },
                                            setFieldProps: function (state, value) {
                                                var _state$ExpenseAmount;
                                                return {
                                                    type: FormItemTypes.Button,
                                                    variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                                    color: 'secondary',
                                                    sx: {
                                                        fontWeight: 'strong',
                                                        color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                        bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                                    },
                                                    children: ['Accepted', /*#__PURE__*/ React.createElement(Chip, {
                                                            variant: "filled",
                                                            size: "small",
                                                            color: "secondary",
                                                            sx: {
                                                                fontWeight: 'medium',
                                                                color: 'text.primary'
                                                            },
                                                            label: (_state$ExpenseAmount = state === null || state === void 0 ? void 0 : state.ExpenseAmount) !== null && _state$ExpenseAmount !== void 0 ? _state$ExpenseAmount : 0
                                                        })]
                                                };
                                            }
                                        }, {
                                            type: FormItemTypes.Button,
                                            label: '',
                                            name: 'Corrective action planned',
                                            columnSize: 0,
                                            variant: 'text',
                                            color: 'secondary',
                                            size: 'small',
                                            fullWidth: true,
                                            setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    return [2 /*return*/, {
                                                            SelectedButton: field.name
                                                        }];
                                                });
                                            }); },
                                            setFieldProps: function (state, value) {
                                                var _state$ClaimAmount;
                                                return {
                                                    type: FormItemTypes.Button,
                                                    variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                                    color: 'secondary',
                                                    sx: {
                                                        fontWeight: 'strong',
                                                        color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                        bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100",
                                                        width: 'max-content'
                                                    },
                                                    children: ['Corrective action planned', /*#__PURE__*/ React.createElement(Chip, {
                                                            variant: "filled",
                                                            size: "small",
                                                            color: "secondary",
                                                            sx: {
                                                                fontWeight: 'medium',
                                                                color: 'text.primary'
                                                            },
                                                            label: (_state$ClaimAmount = state === null || state === void 0 ? void 0 : state.ClaimAmount) !== null && _state$ClaimAmount !== void 0 ? _state$ClaimAmount : 0
                                                        })]
                                                };
                                            }
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.Custom,
                    name: 'IRSCatalog',
                    columnSize: 12,
                    element: isMobile ? IRsMobileView : CQAIRsCatalog
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, null), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        gridProps: {
            spacing: 0
        },
        formData: formData
    }));
};
export default CQA_IRs;
